import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { AngularEnvironment } from '../env';


/**
 * This function should be called within the app's main.ts
 * prior to the call to Angular's bootstrapApplication
 */
export async function initializeInternalAuth(environment: AngularEnvironment) {


	//
	// Perform Firebase Initialization
	//
	const firebaseConfig = { ...environment.firebaseConfig };
	const domain = document?.location?.hostname?.toLowerCase();
	if (!domain.includes('localhost')) {
		firebaseConfig.authDomain = domain;
	}

	const app = firebase.initializeApp(firebaseConfig);
	const auth = firebase.auth(app);
	const x = app.auth();
	auth.useDeviceLanguage();

	//
	// Immediately get the redirect result.
	//
	const result = await auth.getRedirectResult();
	const user = result ? result.user : null;

	console.log(`initializeFirebase() User`, user);
}